import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { GridComponent } from '@progress/kendo-angular-grid';
import { ViewType } from '../../../core/Enums';

@Component({
  selector: 'app-mf-master-detail-grid',
  templateUrl: './mf-master-detail-grid.component.html',
  styleUrls: ['./mf-master-detail-grid.component.css']
})
export class MfMasterDetailGridComponent implements OnInit {
  @ViewChild('grid', { static: true }) grid: GridComponent;
  constructor() { }
  private _data: any;
  @Output() public dataChange = new EventEmitter();
  @Input() public multiInstanceFormFields: any = [];
  @Input() public formField: any;
  @Input() public set data(value) {
    this._data = value;
    this.dataChange.emit(value);
  };
  public get data() {
    return this._data;
  };
  @Input() public parent: any;
  @Input() public formControlInstance: any;
  @Input() public set expandIndex(value) {
    if (typeof value != "undefined") {
      this.collapseAll();
      this.grid.expandRow(value)
    }


  }
  ngOnInit() {
  }
  public get columns() {
    if (this.multiInstanceFormFields.length == 0)
      return [];
    if (this.formField && this.formField.fieldOptions && this.formField.fieldOptions.instanceFields)
      return this.formField.fieldOptions.instanceFields
    else return [];
  }
  public displayValue(instanceFormField, rowIndex) {

    var value = '';
    if (!this.data || !this.data[rowIndex])
      return value;
    if (instanceFormField.multiInstanceSetup && instanceFormField.multiInstanceSetup.tableCellValueTemplate) {
      return instanceFormField.multiInstanceSetup.tableCellValueTemplate(this.data[rowIndex].data ? this.data[rowIndex].data : this.data[rowIndex]);
    }
    if (instanceFormField.multiInstanceSetup && instanceFormField.multiInstanceSetup.displayField) {
      if (!(this.data[rowIndex].data ? this.data[rowIndex].data : this.data[rowIndex]))
        return value;
      return (this.data[rowIndex].data ? this.data[rowIndex].data : this.data[rowIndex])[instanceFormField.multiInstanceSetup.displayField];
    }
    if (this.data && this.data[rowIndex] )
      value = (this.data[rowIndex].data ? this.data[rowIndex].data : this.data[rowIndex])[instanceFormField.fieldOptions && instanceFormField.fieldOptions.dbField ? instanceFormField.fieldOptions.dbField : instanceFormField.field]
    if (instanceFormField.viewType == ViewType.Dropdown) {
      if (instanceFormField.fieldOptions && instanceFormField.fieldOptions.lookups) {
        var selected = instanceFormField.fieldOptions.lookups.filter(o => o.value == value);
        if (selected.length > 0)
          value = selected.label;
      }
    }
    return value;
  }
  expandAll() {
    this.multiInstanceFormFields.forEach((o, i) => {
      this.grid.expandRow(i)
    })
  }
  collapseAll() {
    this.multiInstanceFormFields.forEach((o, i) => {
      this.grid.collapseRow(i)
    })
  }

  public formFieldClassName(formField) {
    return (formField.fieldOptions.className && {}.toString.call(formField.fieldOptions.className) === '[object Function]' ? formField.fieldOptions.className(this.data) : formField.className) + (formField.fieldOptions.enableNA ? " mfx-col-na" : "");
  }
}
